import { Table } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';

export const CustomTable = styled(Table)(({ theme }) => ({
  backgroundColor: '#d3d3d3', // 背景色
  
  // ヘッダーセル
  '& thead th': {
    backgroundColor: alpha(theme.palette.fourthly.main, 0.9),
    color: '#fff',
    borderRight: '1px solid #fff',
    borderColor: 'rgba(51, 64, 78, 0.9)',
  },

  '& .header_color_attention': {
    backgroundColor: theme.palette.fourthly.main,
  },

  // 交互色
  '& tbody tr:nth-of-type(odd)': {
    backgroundColor: '#fff', // 奇数行の背景色を設定
  },
  '& tbody tr:nth-of-type(even)': {
    backgroundColor: '#eaedf7',  // 偶数行の背景色を設定
  },

  // '& tbody tr:hover': {
  //   backgroundColor: '#ffe4e1', // ホバー時の背景色
  // },
  // 行選択
  '& tbody tr.Mui-selected': {
    backgroundColor: '#ffb6c1',
  },
  '& tbody tr.Mui-selected:hover': {
    backgroundColor: '#ffb6c1',
  },

  // セルの右枠線
  '& td': {
    borderRight: '1px solid rgba(224, 224, 224, 1)',
  },
}));